import { i18n } from 'i18n';

import { WithdrawalRequestStatusEnum } from '../api/codegen.api';

export const TRANSACTION_STATUSES = {
	[WithdrawalRequestStatusEnum.InProgress]: i18n.t('In progress'),
	[WithdrawalRequestStatusEnum.Success]: i18n.t('Success'),
	[WithdrawalRequestStatusEnum.Failed]: i18n.t('Failed'),
};
